import { FormOption } from 'types';
import {
  COLLECT_TYPE,
  EXCHANGE_REASON,
  REQUEST_TYPE,
  RETURN_TYPE,
} from 'types/exchange-return';

export const requestTypes: FormOption[] = [
  {
    label: 'Transpostadora para coletar no cliente',
    value: REQUEST_TYPE.TO_COLLECT_AT_CUSTOMER,
  },
  {
    label: 'Cancelamento/Estorno',
    value: REQUEST_TYPE.CANCEL_OR_REFUND_TO_CUSTOMER,
  },
];

export const collectTypes: FormOption[] = [
  {
    label: 'Troca',
    value: COLLECT_TYPE.EXCHANGE,
  },
  { label: 'Devolução', value: COLLECT_TYPE.RETURN },
];

export const returnTypes: FormOption[] = [
  { label: 'Total', value: RETURN_TYPE.TOTAL },
  { label: 'Parcial', value: RETURN_TYPE.PARTIAL },
];

export const exchangeReasons: FormOption[] = [
  { label: 'Tamanho errado', value: EXCHANGE_REASON.SIZE },
  { label: 'Defeito ou dano', value: EXCHANGE_REASON.DEFECT_OR_DAMAGE },
  {
    label: 'Divergente no site',
    value: EXCHANGE_REASON.DIVERGENT_OF_WEBSITE,
  },
  { label: 'Abandono', value: EXCHANGE_REASON.ABANDONMENT },
  { label: 'Cliente insatisfeito', value: EXCHANGE_REASON.UNSATISFIED },
  { label: 'Produto em falta', value: EXCHANGE_REASON.STORE_OUT_OF_STOCK },
  {
    label: 'Loja enviou o produto errado',
    value: EXCHANGE_REASON.STORE_SENT_WRONG_PRODUCT,
  },
  { label: 'Outros', value: EXCHANGE_REASON.OTHERS },
];
